// IdContext.js
import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';

/**
 * @typedef {Object} IdContextType
 * @property {string|null} deviceId
 */

/** @type {IdContextType} */
const defaultValue = { deviceId: null };

/** @type {React.Context<IdContextType>} */
const DeviceIdContext = createContext(defaultValue);

export function DeviceIdProvider({ children, deviceId }) {
    return (
        <DeviceIdContext.Provider value={{ deviceId }}>
            {children}
        </DeviceIdContext.Provider>
    );
}

DeviceIdProvider.propTypes = {
    children: PropTypes.node.isRequired,
    initialId: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
};

export function useDeviceId() {
    const ctx = useContext(DeviceIdContext);
    if (!ctx) throw new Error('useDeviceId must be used within DeviceIdProvider');
    return ctx;
}

export default DeviceIdContext;
